import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { candidateEndpoints } from '@/modules/candidates/constants';
import { candidateJobQueryKeys } from '@/modules/candidates/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

interface PrescreenCandidateJobParams {
  jobId: string;
  candidateId: string;
}

export const usePrescreenCandidateJobMutation = () => {
  return useMutation({
    mutationFn: ({ jobId, candidateId }: PrescreenCandidateJobParams) =>
      fetchClient.POST(candidateEndpoints.prescreenCandidate, {
        params: {
          path: {
            jobId,
            candidateId,
          },
        },
      }),
    onSettled: (_data, _error, variables) => {
      const { jobId, candidateId } = variables;
      const detailQueryKey = candidateJobQueryKeys.detail(jobId, candidateId);
      const listQueryKey = candidateJobQueryKeys.lists(jobId);

      invalidateQuery(listQueryKey)();
      invalidateQuery(detailQueryKey)();
    },
  });
};
